<template>
    <div class="filled-content">
        <v-toolbar app flat dark tabs color="primary">
            <v-btn icon @click="gotoBack()">
                <v-icon>arrow_back</v-icon>
            </v-btn>
            <v-toolbar-title>Ble Detail</v-toolbar-title>
            <v-btn icon @click="searchForDevice()">
                <v-icon>refresh</v-icon>
            </v-btn>
        </v-toolbar>

        <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="timeout">
            {{ snackbarMessage }}
        </v-snackbar>

        <v-content class="uf-form">
            <v-progress-linear :indeterminate="true" class="ma-0" v-if="scanning && !bleDevice"></v-progress-linear>
            <template v-if="(!scanning && !bleDevice) || invalidDevice">
                <v-container class="item-group" mb-4>
                    <h3>Geen E-finder gevonden</h3><br>
                    <ol>
						<li>Gebruik de meegeleverde kabel om je E-finder aan te sluiten aan het netstroom.</li>
						<li>Controleer of de code op je E-finder klopt: {{ device.eid.substr(-6) }}</li>
						<li>Haal je E-finder even van het netstroom af en zet hem er dan weer aan, klik daarna op opnieuw verbinden hier onder.</li>
                    </ol>
                    <v-btn :loading="saving" block dark depressed large color="primary" @click="searchForDevice()"
                           class="mt-4">
                        Opnieuw verbinden
                    </v-btn>
                </v-container>
            </template>
            <template v-if="bleDevice && !invalidDevice">
                <v-list class="mb-2">
                    <v-list-tile one-line>
                        <v-list-tile-content>
                            <v-list-tile-title>RSSI</v-list-tile-title>
                        </v-list-tile-content>
                        <v-list-tile-action>
                            {{ rssi }}
                        </v-list-tile-action>
                    </v-list-tile>
                </v-list>

                <v-list class="mb-2">
                    <v-subheader>Activation</v-subheader>
                    <v-list-tile one-line>
                        <v-list-tile-content>
                            <v-list-tile-title>E-finder activeren</v-list-tile-title>
                        </v-list-tile-content>
                        <v-list-tile-action>
                            <v-btn small @click="activateDevice" :loading="activating">Versturen</v-btn>
                        </v-list-tile-action>
                    </v-list-tile>
<!--                    <v-list-tile one-line>-->
<!--                        <v-list-tile-content>-->
<!--                            <v-list-tile-title>E-finder deactiveren</v-list-tile-title>-->
<!--                        </v-list-tile-content>-->
<!--                        <v-list-tile-action>-->
<!--                            <v-btn small @click="deactivateDevice">Versturen</v-btn>-->
<!--                        </v-list-tile-action>-->
<!--                    </v-list-tile>-->
                </v-list>
                <v-list class="mb-2">
                    <v-subheader>WiFi</v-subheader>
                    <v-list-tile one-line v-if="!updateWifi">
                        <v-list-tile-content>
                            <v-list-tile-title>Wifi gegevens</v-list-tile-title>
                        </v-list-tile-content>
                        <v-list-tile-action>
                            <v-btn small @click="updateWifi = true">Aanpassen</v-btn>
                        </v-list-tile-action>
                    </v-list-tile>
                    <div v-if="updateWifi">
                        <v-list-tile>
                            <v-text-field
                                    v-model="characteristics.wifiName"
                                    label="WiFi Name"
                            >
                            </v-text-field>
                        </v-list-tile>
                        <v-list-tile class="mt-2">
                            <v-text-field
                                    type="password"
                                    v-model="characteristics.wifiKey"
                                    label="WiFi Key"
                            >
                            </v-text-field>
                        </v-list-tile>
                        <v-list-tile class="mt-2">
                            <v-list-tile-content></v-list-tile-content>
                            <v-list-tile-action>
                                <v-btn small @click="saveWifi()">Opslaan</v-btn>
                            </v-list-tile-action>
                        </v-list-tile>
                    </div>
                </v-list>
            </template>
        </v-content>
    </div>
</template>

<script>

    const a = {
        'name': 'E-finder 00100201',
        'id': 'CC:50:E3:B9:92:AE',
        'advertising': {},
        'rssi': -43,
        'services': ['1801', '1800', 'eac0d61a-31c2-e3f3-baeb-38ddd48474eb', '1fb91a52-a1db-49da-a31a-0401cc94acc4', 'c01ff0ad-ff8f-43b9-a6ef-cf71ba1eb665'],
        'characteristics': [{
            'service': '1801',
            'characteristic': '2a05',
            'properties': ['Indicate'],
            'descriptors': [{'uuid': '2902'}]
        }, {'service': '1800', 'characteristic': '2a00', 'properties': ['Read']}, {
            'service': '1800',
            'characteristic': '2a01',
            'properties': ['Read']
        }, {
            'service': '1800',
            'characteristic': '2aa6',
            'properties': ['Read']
        }, {
            'service': 'eac0d61a-31c2-e3f3-baeb-38ddd48474eb',
            'characteristic': 'eac0d61a-0000-e3f3-baeb-38ddd48474eb',
            'properties': ['Write']
        }, {
            'service': 'eac0d61a-31c2-e3f3-baeb-38ddd48474eb',
            'characteristic': 'eac0d61a-0001-e3f3-baeb-38ddd48474eb',
            'properties': ['Write']
        }, {
            'service': 'eac0d61a-31c2-e3f3-baeb-38ddd48474eb',
            'characteristic': 'eac0d61a-0002-e3f3-baeb-38ddd48474eb',
            'properties': ['Read', 'Indicate'],
            'descriptors': [{'uuid': '2902'}]
        }, {
            'service': '1fb91a52-a1db-49da-a31a-0401cc94acc4',
            'characteristic': '1fb91a52-0000-49da-a31a-0401cc94acc4',
            'properties': ['Write']
        }, {
            'service': 'c01ff0ad-ff8f-43b9-a6ef-cf71ba1eb665',
            'characteristic': 'c01ff0ad-0000-43b9-a6ef-cf71ba1eb665',
            'properties': ['Write']
        }]
    };

    const characteristics = {
        activation: {
            uuid: '1fb91a52-0000-49da-a31a-0401cc94acc4'
        },
        activationSuccess: {
            uuid: '1fb91a52-0001-49da-a31a-0401cc94acc4',
        },
        ssid: {
            uuid: 'eac0d61a-0000-e3f3-baeb-38ddd48474eb'
        },
        password: {
            uuid: 'eac0d61a-0001-e3f3-baeb-38ddd48474eb'
        },
        isFound: {
            uuid: 'c01ff0ad-0000-43b9-a6ef-cf71ba1eb665'
        }
    };

    function stringToBytes(_str) {
        let str = _str + '';
        let a = new Uint8Array(str.length);
        for (let i = 0, l = str.length; i < l; i++) {
            a[i] = str.charCodeAt(i);
        }
        return a.buffer;
    }

    // ASCII only
    function bytesToString(buffer) {
        return String.fromCharCode.apply(null, new Uint8Array(buffer));
    }

    export default {
        data() {
            return {
              	activating: false,
              	available: 'checking',
              	activated: null,

                timeout: 3000,
                saving: false,
                snackbarColor: '',
                snackbarMessage: '',
                snackbar: false,
                updateWifi: false,
                scanning: true,
                hasScanned: false,
                id: this.$route.params.id,
                bleDevice: null,
                wifiDialog: false,
                invalidDevice: false,
                response: '',
                rssi: null,
                rssiInterval: null,
                activating: false,
                characteristics: {
                    activated: false,
                    wifiName: '',
                    wifiKey: '',
                    isFound: false,
                }
            };
        },
        computed: {
            deviceJson() {
                return JSON.stringify(this.device);
            },
            device() {
                return this.$store.getters.device;
            }
        },
        methods: {
            searchForDevice() {
                if (typeof ble === 'undefined') return false;
                this.scanning = true;
                this.hasScanned = true;

                ble.startScan([], (device) => {
                    if (!device.name || !device.id) return;

                    if (device.advertising && device.advertising.kCBAdvDataLocalName)
                        device.name = device.advertising.kCBAdvDataLocalName;

                    if (device.name.substr(-6) == this.device.id_for_humans.substr(-6)) {
                        ble.stopScan();
                        this.connect(device.id);
                    }
                });

                setTimeout(ble.stopScan, 5000,
                    () => this.scanning = false,
                    () => this.scanning = false
                );
            },

            connect(deviceId) {
                if (typeof ble === 'undefined') return console.log('BLE not available');

                this.bleDevice = null;

                ble.connect(deviceId, (device) => {
                    this.bleDevice = device;

                    if (!this.validateDevice())
                        return this.invalidDevice = true;

					this.available = !!this.getCharacteristic(characteristics.activationSuccess.uuid) ? 'available' : 'not available';

                    this.startMeasuringRssi(deviceId);
                });
            },

            getCharacteristic(uuid) {
                if (!this.bleDevice && !this.bleDevice.characteristics) return undefined;

                return this.bleDevice.characteristics.find(deviceCharacteristic => {
                    return deviceCharacteristic.characteristic.toUpperCase() === uuid.toUpperCase();
                });
            },

            validateDevice() {
                let requiredCharacteristics = Object.keys(characteristics)
                    .reduce((arr, key) => [...arr, characteristics[key]], [])
					.filter(characteristic => {
						return this.getCharacteristic(characteristic.uuid) === undefined;
					});

                return (requiredCharacteristics.length <= 1);
            },

            startMeasuringRssi(deviceId) {
                clearInterval(this.rssiInterval);
                this.rssiInterval = setInterval(() => {
                    ble.readRSSI(deviceId,
                        rssi => this.rssi = rssi,
                        err => clearInterval(this.rssiInterval)
                    );
                }, 1000);
            },
            gotoBack() {
                this.$router.go(-1);
            },

            activateDevice() {
                if (!this.bleDevice) return;

                const characteristic = this.getCharacteristic(characteristics.activation.uuid);
                const characteristicSuccess = {
                    service: '1fb91a52-a1db-49da-a31a-0401cc94acc4',
                    characteristic: 'eac0d61a-0002-e3f3-baeb-38ddd4847eb'
                };;

                let data = new Uint8Array(1);
                data[0] = 1;

                if(characteristicSuccess) {

					const timeout = setTimeout(() => {
						ble.stopNotification(this.bleDevice.id, characteristicSuccess.service, characteristicSuccess.characteristic);
						//reject();
					}, 10000);

					ble.startNotification(this.bleDevice.id, characteristicSuccess.service, characteristicSuccess.characteristic, (data) => {
						ble.stopNotification(this.bleDevice.id, characteristicSuccess.service, characteristicSuccess.characteristic);
						clearTimeout(timeout);
						this.activating = false;
						this.activated = true;
						this.successMessage('E-finder geactiveerd');
					});
                }

                ble.write(this.bleDevice.id, characteristic.service, characteristic.characteristic, data.buffer,
                    () => {
                      	if(characteristicSuccess) this.successMessage('E-finder geactiveerd');
					},
                    () => {
                        this.errorMessage('Geen vebinding, probeer op nieuw.');
                        this.bleDevice = null;
                    }
                );
            },

            deactivateDevice() {
                if (!this.bleDevice) return;

                const characteristic = this.getCharacteristic(characteristics.activation.uuid);

                let data = new Uint8Array(1);
                data[0] = 0;

                ble.write(this.bleDevice.id, characteristic.service, characteristic.characteristic, data.buffer,
                    () => this.successMessage('E-finder gedeactiveerd'),
                    () => {
                        this.errorMessage('Geen vebinding, probeer op nieuw.');
                        this.bleDevice = null;
                    }
                );
            },

            saveWifi() {
                if (!this.bleDevice) return;

                const characteristicName = this.getCharacteristic(characteristics.ssid.uuid);
                const characteristicPassword = this.getCharacteristic(characteristics.password.uuid);

                const wifiName = stringToBytes(this.characteristics.wifiName);
                const wifiKey = stringToBytes(this.characteristics.wifiKey);

                ble.write(this.bleDevice.id, characteristicName.service, characteristicName.characteristic, wifiName,
                    () => {
                        this.updateWifi = false;
                        this.successMessage('WiFi opgeslagen');
                    },
                    () => {
                        this.errorMessage('Geen vebinding, probeer op nieuw.');
                        this.bleDevice = null;
                    }
                );
                ble.write(this.bleDevice.id, characteristicPassword.service, characteristicPassword.characteristic, wifiKey,
                    () => console.log('BLE - Wifi Password saved')
                );
            },

            successMessage(message) {
                this.snackbarColor = 'success';
                this.snackbar = this.snackbarMessage = message;
            },

            errorMessage(message) {
                this.snackbarColor = 'error';
                this.snackbar = this.snackbarMessage = message;
                this.bleDevice = null;
            },

            foundDevice() {
                if (!this.bleDevice) return;

                const characteristic = this.getCharacteristic(characteristics.isFound.uuid);

                let data = new Uint8Array(1);
                data[0] = 1;

                ble.write(this.bleDevice.id, characteristic.service, characteristic.characteristic, data.buffer);
            }
        },
        created() {
            this.snackbarMessage = '';

            this.$store.dispatch('selectDevice', this.$route.params.id)
                .then(device => this.searchForDevice());

            // if(WifiWizard2) {
            //   WifiWizard2.getConnectedSSID()
            //     .then((ssid) => {
            //       this.characteristics.wifiName = ssid;
            //     });
            // }
        }
    };
</script>
